import { createSelector } from '@reduxjs/toolkit';
import { BatchDefinitionsState } from 'ducks/batch-definitions/slices';
import { RootState } from 'store';

const batchDefinitionsSlice = (state: RootState) => state.batch_definitions;

export const selectBatchDefinitions = createSelector([batchDefinitionsSlice], (state): BatchDefinitionsState => state);
